/** @flow */
export default {
  en: {
    // Common
    WELCOME: "Welcome",
    WELCOME_TO_FIRSTCAREINSIGHT: "Welcome to GoodShapeCentral! Where do you want to go?",
    PLACES_TO_GO: "Places To Go",
    VIEW_MY_DETAILS: "View My Details",
    HIERARCHY: "Hierarchy",
    SERVICE: "Service",
    EMPLOYEE: "Employee",
    SIP_USER_GUIDE: "SIP User Guide",
    INCOMING_ABSENCE_CALLS: "Incoming Absence Calls",
    OUTBOUND_CALLBACKS: "Outbound Callbacks",
    DASHBOARD: "Dashboard",
    CONTACT_CENTRE_MANAGEMENT: "Contact Centre Management",
    SYSTEM_MANAGEMENT: "System Management",

    ADMINISTRATION_DESCRIPTION:
      "Administer the GoodShape service, including all {Hierarchy}, {Service}, {Employee} and {Data Admin}.",
    ADMINISTRATION_ACTION_TEXT: "Manage Service",

    RECORDING: "Recording",
    RECORDING_DESCRIPTION: "Process {Incoming Absence Calls} and complete {Outbound Callbacks}.",
    RECORDING_ACTION_TEXT: "Open Recording",

    REPORTING: "Reporting",
    REPORTING_DESCRIPTION:
      "Access the GoodShape absence reporting suite. Why not get started by visiting your {Dashboard}?",
    REPORTING_ACTION_TEXT: "Visit Dashboard",

    MANAGEMENT: "Management",
    MANAGEMENT_DESCRIPTION:
      "Carry out key GoodShape management updates, including {Contact Centre Management} and {System Management}.",
    MANAGEMENT_ACTION_TEXT: "Open Management",

    USER_SECTION_DESCRIPTION:
      "View your own absence details as well as manage your GoodShapeCentral! profile, reset your password and update your preferences.",
    GO_TO_MY_DETAILS: "Go To My Details",

    GOOD_SHAPE_ACADEMY: "GoodShape Academy",
    ABSENCE_RATES_AND_REASONS: "Absence Rates and Reasons",
    MY_DASHBOARD: "My Dashboard",
    CURRENT_ABSENCE_HEADLINES: "Current Absence Headlines",
    TUTORIALS_AND_TRAINING: "Tutorials And Training",
    VERSION_CONTROL_VERSION_TITLE: "Version",
    VERSION_CONTROL_VERSION: "0.9.5",
    VERSION_CONTROL_DATE_TITLE: "Date Released",
    VERSION_CONTROL_DATE: "09/09/2019",
    VERSION_CONTROL_NOTES_TITLE: "Release Notes",
    VERSION_CONTROL_NOTES:
      "First release of all Absence Reason Trends and an updated version of the Absence Rate Trends which now includes trend indicators and charts.",
    VERSION_CONTOL_NOTES_ADDITIONAL:
      'In addition, absence monitoring actions can now be completed on an Employee\'s record, the missing "All" filter has been added to the Absence Details report and several new filters have been added to the employee focus list.',
    THANK_YOU_FOR_REGISTERING: "Thank you for registering!",
    YOU_ARE_ELIGIBLE: "You're now eligible to download the GoodShape app!",
    EMPLOYEE_PAGE_LIST_LINE_1: "Report, update and close absences 24/7.",
    EMPLOYEE_PAGE_LIST_LINE_2: "Access a library of wellbeing content advice.",
    EMPLOYEE_PAGE_LIST_LINE_3: "Manage your GoodShape profile.",

    EMPLOYEE_PAGE_INSTRUCTIONS:
      "Once downloaded, you can login using your GoodShape login details.",

    AVAILABLE_PRODUCTS: "Available Products",

    GOOD_SHAPE_CENTRAL: "GoodShapeCentral",
    MANAGEMENT_PLATFORM: "Management Platform",
    GOOD_SHAPE_HEALTH: "GoodShapeHealth",
    TELEHEALTH_SERVICE: "24/7 Telehealth Service",
    GOOD_SHAPE_DEVELOPER: "GoodShapeDeveloper",
    API_DEVELOPER_HUB: "API Developer Hub",
    GOOD_SHAPE_NAVIGATOR: "GoodShapeNavigator",
    REFERRAL_MANAGEMENT: "Referral Management",
    GOOD_SHAPE_MONITOR: "GoodShapeMonitor",
    ABSENCE_MONITORING: "Absence Monitoring",
    GOOD_SHAPE_SERVICE_HUB: "GoodShapeServiceHub",
    HEALTH_PROVIDER_MANAGEMENT: "Health Provider Management",
    PROVIDER: "Provider",
    SERVICE_HUB: "Service Hub",
    SERVICE_HUB_PAGE_INTRO_TEXT:
      "The wellbeing services below can be set-up on GoodShapeCentral and made available to your staff in the GoodShape app. If you work with one of the suppliers below, access our Services Hub to learn how you can increase staff engagement with the wellbeing services you provide.",
    ACCESS_SERVICE_HUB: "Access Service Hub",

    // Health
    GOOD_SHAPE_HEALTH_FEATURES:
      "Nurse Led Telehealth service. • 24/7 appointment booking • Confidential advice and support. • Assessment of absences and return to work dates. • Clinical support covering 30+ specialities. • Helping employees return to work safely. • And more!",
    GOOD_SHAPE_HEALTH_BENEFITS:
      "Reduced duration of sickness absences. • Reduced symptom reoccurrence for employees. • Early detection of potential health issues. • Support during code red incidents.",
    GOOD_SHAPE_HEALTH_BOTTOMLINE: "Contact your GoodShape Client Success Manager to learn more.",

    // Developer
    GOOD_SHAPE_DEVELOPER_FEATURES:
      "Developer Hub Access. • Unlimited application connections. • API's for importing and maintaining employee data. • API's for extracting absence data. • Connect to Payroll systems. • Connect to Rostering systems. • And more!",
    GOOD_SHAPE_DEVELOPER_BENEFITS:
      "Automation of data entry into HR systems. • Reduced manual data maintenance. • Quicker submissions to Payroll. • Increased accuracy of data.",
    GOOD_SHAPE_DEVELOPER_BOTTOMLINE: "Contact your GoodShape Client Success Manager to learn more.",

    //Navigator
    GOOD_SHAPE_NAVIGATOR_FEATURES:
      "Managed referrals into Occupational Health. • Compatible with in-house and external OH teams. • Customised referral forms. • Line Manager guidance and action tracking. Reports on new, active and closed referrals. Referral History reports within Employee Records. And more!",
    GOOD_SHAPE_NAVIGATOR_BENEFITS:
      "Faster Occupational Health referrals. Reduced waiting times and lost referrals. Greater transparency. Earlier intervention in complex absences.",
    GOOD_SHAPE_NAVIGATOR_BOTTOMLINE: "Contact your GoodShape Client Success Manager to learn more.",

    //Monitor
    GOOD_SHAPE_MONITOR_FEATURES:
      "Track employees in the absence management process. • Configure alerts for each step of the process. • Book and manage review meetings. • Track employee warnings and potential dismissals. • View reports on manager process compliance. • View extra reports within employee records. • And more!",
    GOOD_SHAPE_MONITOR_BENEFITS:
      "Greater transparency over the process. • Increased compliance and reduced risk. • Fair and consistent treatment of employees. • Increased efficiency and reduced admin.",
    GOOD_SHAPE_MONITOR_BOTTOMLINE: "Contact your GoodShape Client Success Manager to learn more.",

    //ServiceHub
    GOOD_SHAPE_SERVICE_HUB_FEATURES:
      "Feature all your wellbeing services in the GoodShape app. • Track utilisation levels of each service. • Targeted signposting to relevant employees. • Capture of employee feedback about services. • Analysis of service impact. • Benchmarking comparisons. • And more!",
    GOOD_SHAPE_SERVICE_HUB_BENEFITS:
      "Increased support for your employees. • Increased utilisation of your wellbeing services. • Understanding of employee satisfaction. • Greater understanding of return on investment.",
    GOOD_SHAPE_SERVICE_HUB_BOTTOMLINE:
      "Contact your GoodShape Client Success Manager to learn more.",

    //ServiceHub
    GOOD_SHAPE_SERVICE_HUB2_FEATURES:
      "Feature all your wellbeing services in the GoodShape app. • Track utilisation levels of each service. • Targeted signposting to relevant employees. • Capture of employee feedback about services. • Analysis of service Impact. • Benchniarking comparisons. • And more! ",
    GOOD_SHAPE_SERVICE_HUB2_BENEFITS:
      "Increased support for your employees. • Increased utilisation of your wellbeing services. • Understanding of employee satisfaction. • Greater understanding of return on Investment.",
    GOOD_SHAPE_SERVICE_HUB2_BOTTOMLINE:
      "Contact your GoodShape Client Success Manager to learn more.",

    //GoodShape Plumm
    GOOD_SHAPE_PLUMM_FEATURES_INTROLINE:
      "GoodShape are pleased to announce that we have formed a partnership with Plumm, the UK’s fastest growing provider of Mental Health solutions. Together, we can provide an integrated service that helps to improve employee wellbeing and reduce mental health related absence.",
    GOOD_SHAPE_PLUMM_FEATURES:
      "24/7 Unlimited Chat therapy sessions. • Video Therapy sessions. • Online Courses, Workshops and Classes. • Resilience and Mindfulness training. • Integrated GoodShape referrals. • Combined GoodShape & Plumm data analytics. • And More!",
    GOOD_SHAPE_PLUMM_BENEFITS:
      "Improved employee wellbeing. • Increased employee morale. • Reduced mental health absence. • Greater understanding of mental health.",
    GOOD_SHAPE_PLUMM_BOTTOMLINE: "Contact your GoodShape Client Success Manager to learn more. ",

    //MY GOODSHAPE
    MY_GOODSHAPE: "My GoodShape",
    MANAGE_ABSENCES: "Manage Absences",
    MANAGE_ABSENCES_DESCRIPTION: "Report and manage your absences",
    GET_ADVICE: "Get Advice",
    GET_ADVICE_DESCRIPTION: "Browse the Wellbeing Advice Library",
    DOWNLOAD_THE_APP: "Download the App",
    DOWNLOAD_THE_APP_DESCRIPTION: "Access support on the go",
    ADVICE_LIBRARY: "Advice Library",
    SERVICE_DIRECTORY: "Service Directory",
    VISIT_WEBSITE: "Visit Website",
    SERVICE_DESK: "Service Desk",
    CUSTOMER_SUPPORT: "Customer Support",
    SERVICE_DESK_DESCRIPTION:
      "Many queries can be supported by GoodShape Administrators within your organisation – Please check and follow your internal processes for raising GoodShape queries and if you still need support please click on the appropriate button below and complete the necessary form.",
    SERVICE_DESK_FORM_WARNING:
      "Please complete all mandatory fields below. Before GoodShape can process your request, we may need authorisation from your employer. Check your internal processes and attach a completed approval form, if required.",
    PREVIOUS_TICKETS: "Previous Tickets",
    UNABLE_TO_ACTION: "Unable To Action",
    REQUEST_NOT_AUTHORISED: "Request Not Authorised",
    GO_TO_ACADEMY: "Visit the GoodShape Academy",
    TODAYS_ACTIVITIES: "Today’s Activities",
    RECENTLY_VISITED: "Recently Visited",
    SUBMIT_REQUEST: "Submit Request",
    SERVICE_DESK_SELF_MANAGE_BUTTON_TEXT_canAddAbsence: "Add Absence Now",
    SERVICE_DESK_SELF_MANAGE_TEXT_canAddAbsence:
      "Our standard response time is 2 working days. However, your organisation has granted you self-service permissions. This means that you can now add absences directly to your employees' records. If you would prefer to do that, visit the absences tab of the employee record and click the “Add New Absence” button. What would you like to do?",
    SERVICE_DESK_SELF_MANAGE_BUTTON_TEXT_canUpdateAbsence: "Update Absence Now",
    SERVICE_DESK_SELF_MANAGE_TEXT_canUpdateAbsence:
      "Our standard response time is 2 working days. However, your organisation has granted you self-service permissions. This means that you can update and close your employee’s absences instantly. If you would prefer to do that, visit the absences tab of the employee record and click the Edit button to make the relevant changes. What would you like to do?",
    SERVICE_DESK_SELF_MANAGE_BUTTON_TEXT_canCancelAbsence: "Cancel Absence Now",
    SERVICE_DESK_SELF_MANAGE_TEXT_canCancelAbsence:
      "Our standard response time is 2 working days. However, your organisation has granted you self-service permissions. This means that you can cancel absences reported by your employees instantly. If you would prefer to do that, visit the absences tab of the employee record, click the action button for the relevant absence and click Cancel. What would you like to do?",
    SERVICE_DESK_SELF_MANAGE_BUTTON_TEXT_allowNotificationContactAction:
      "Add Notification Contact Now",
    SERVICE_DESK_SELF_MANAGE_TEXT_allowNotificationContactAction:
      "Our standard response time is 2 working days. However, your organisation has granted you self-service permissions. This means that you can add notification contacts to any employee record you have full access to on the system. Simply visit their employee record, select the Contacts tab and click the Add New Recipient button. What would you like to do?",
  },
};
